<template>
  <AsyncData :request-state="requestState">
    <v-data-table
      v-if="requestState === 'Success'"
      :headers="headers"
      :items="filteredItems"
      :total-items="response.total"
      item-key="caseId"
      :pagination.sync="proxyPagination"
      :rows-per-page-items="[2, 10, 25, 50, 100]"
      rowsPerPage>
      <template slot="items" slot-scope="props">
        <invoice-candidate-log-item :invoice-id="invoiceId" :item="props.item"/>
      </template>
      <template slot="actions-prepend">
        <invoice-case-batch-operations
          :invoice-id="invoiceId"
          :cases-with-log="filteredItems"/>
      </template>
    </v-data-table>
  </AsyncData>
</template>

<script>
  import {mapActions} from "vuex";
  import _ from 'lodash'
  import AsyncData from "../../Ui/AsyncData";
  import ClientInfo from "../../Sales/case/ClientInfo";
  import ServicesInfo from "./../ServicesInfo";
  import MaterialList from "./../MaterialList";
  import DateWithMinutes from '../../Filters/DateWithMinutes.js'
  import NoEmpty from '../../Filters/NoEmpty'
  import ModalJsonView from "../../Ui/ModalJsonView";
  import ModalCaseServiceLog from "../../Sales/case/ModalCaseServiceLog";
  import PrettyAmount from '../../../components/Ui/PrettyAmount'
  import {calculateExecutedPrice} from "../utils";
  import InvoiceCandidateLogItem from './InvoiceCandidateLogItem'
  import InvoiceCaseBatchOperations from "./InvoiceCaseBatchOperations";

  function isItemContainAnomaliesOfType(item, anomalies) {
    return _.findIndex(item.caseAnomalies, it => anomalies.includes(it.type)) > -1
  }

  export default {
    name: 'invoice-candidate-logs',
    components: {
      AsyncData,
      ServicesInfo,
      MaterialList,
      ClientInfo,
      ModalJsonView,
      ModalCaseServiceLog,
      PrettyAmount,
      InvoiceCandidateLogItem,
      InvoiceCaseBatchOperations
    },
    filters: {
      NoEmpty,
      DateWithMinutes
    },
    props: {
      invoiceId: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        showModal: false,
        headers: [
          {
            text: 'Title',
            align: 'left',
            sortable: false,
            value: 'title',
            width: '100px'
          },
          {
            text: 'Status',
            align: 'left',
            sortable: false,
            value: 'status',
            width: '100px'
          },
          {
            text: 'Dates(creation, materials, report sending)',
            align: 'left',
            sortable: false,
            value: 'date',
            width: '200px'
          },
          {
            text: 'Patient Name',
            align: 'left',
            sortable: false,
            value: 'patientName',
            width: '100px'
          },
          {
            text: 'Client',
            align: 'left',
            sortable: false,
            value: 'client',
            width: '100px'
          },
          {
            text: 'Comment',
            align: 'left',
            sortable: false,
            value: 'comment',
            width: '100px'
          },
          {
            text: 'Price',
            align: 'left',
            sortable: false,
            width: '100px'
          },
          {
            text: 'Operations',
            align: 'left',
            sortable: false,
            width: '100px'
          },
          {
            text: 'Services',
            align: 'left',
            sortable: false,
            width: '200px'
          },
          {
            text: 'Materials',
            align: 'left',
            sortable: false,
            width: '200px'
          }
        ],
      }
    },
    mounted() {
      this.invoicesFetchInvoiceLogCandidates({
        invoiceId: this.invoiceId
      })
    },
    computed: {
      dataSection() {
        return this.$store.getters.getInvoiceLogCandidatesSection(this.invoiceId)
      },
      clientFilter() {
        return this.dataSection.clientFilter;
      },
      pagination() {
        return this.dataSection.filter.pagination;
      },
      response() {
        return this.dataSection.response;
      },
      requestState() {
        return this.dataSection.requestState;
      },

      proxyPagination: {
        get() {
          return {
            page: this.pagination.page,
            rowsPerPage: this.pagination.rowsPerPage
          };
        },
        set(newValue) {
          let newPagination = {
            page: newValue.page,
            rowsPerPage: newValue.rowsPerPage
          };

          if (_.isEqual(this.proxyPagination, newPagination)) {
            return
          }

          this.changeFilter({
            invoiceId: this.invoiceId,
            filterDelta: {
              pagination: newPagination
            }
          })
        },
      },
      filteredItems() {
        // anomaly filter
        let result = this.response.items;
        if (this.clientFilter.caseAnomalies.length > 0) {
          result = _.filter(result, it => isItemContainAnomaliesOfType(it, this.clientFilter.caseAnomalies))
        }

        // price
        if (this.clientFilter.executedPriceOver9000) {
          result = _.filter(result, it => this.calculateExecutedPrice(it).amount > 9000)
        }

        return result;
      }
    },
    methods: {
      ...mapActions({
        invoicesFetchInvoiceLogCandidates: 'invoicesFetchInvoiceLogCandidates',
        changeFilter: 'invoicesChangeFilterForInvoiceLogCandidates'
      }),
      calculateExecutedPrice(item) {
        return calculateExecutedPrice(item)
      }
    },
  }
</script>




// WEBPACK FOOTER //
// src/components/analytics/invoices/InvoiceCandidateLogs.vue